import { writable } from 'svelte/store';
function createDecoupledGroupsStore() {
    const { subscribe, set, update } = writable({});
    let currentValue;
    subscribe(currentState => currentValue = currentState);
    return {
        subscribe: subscribe,
        set: (newGroupLockState) => set(newGroupLockState),
        decoupleGroup: (groupName) => update((decoupledGroupsState) => {
            decoupledGroupsState[groupName] = true;
            return decoupledGroupsState;
        }),
        coupleGroup: (groupName) => update((decoupledGroupsState) => {
            decoupledGroupsState[groupName] = false;
            return decoupledGroupsState;
        }),
        isDecoupled: (groupName) => currentValue[groupName],
        updateGroupName: (oldName, newName) => update((state) => {
            state[newName] = state[oldName];
            delete state[oldName];
            return state;
        })
    };
}
export const decoupledGroupsStore = createDecoupledGroupsStore();
